window.obaAddToCart = function obaAddToCart(button) {
  const variantId = Number.parseInt(button.dataset.variantId, 10);
  if (!variantId) {
    console.error('OBA: missing variant ID');
    return;
  }

  button.disabled = true;
  button.setAttribute('data-loading', '');
  button.setAttribute('aria-busy', 'true');
  const originalHTML = button.innerHTML;
  button.innerHTML = '<span class="oba-cart-spinner" aria-hidden="true"></span><span>Adding...</span>';

  const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
    .map((item) => (item instanceof HTMLElement ? item.dataset.sectionId : undefined))
    .filter(Boolean);

  const formData = new FormData();
  formData.append('id', String(variantId));
  formData.append('quantity', '1');

  if (sectionIds.length > 0) {
    formData.append('sections', [...new Set(sectionIds)].join(','));
    formData.append('sections_url', window.location.pathname);
  }

  const shopifyRoot = window.Shopify?.routes?.root || '/';

  fetch(`${shopifyRoot}cart/add.js`, {
    method: 'POST',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      Accept: 'text/html',
    },
    body: formData,
  })
    .then((response) => {
      if (!response.ok) throw new Error(`cart/add failed: ${response.status}`);
      return response.json();
    })
    .then((response) => {
      button.removeAttribute('data-loading');
      button.removeAttribute('aria-busy');
      button.innerHTML = '<span>Added</span>';

      if (response.status) {
        console.error('OBA cart error:', response.message);
        button.innerHTML = '<span>Could not add</span>';
        window.setTimeout(() => {
          button.innerHTML = originalHTML;
          button.disabled = false;
        }, 2000);
        return;
      }

      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: {},
            sourceId: String(variantId),
            data: {
              source: 'oba-product-hover',
              itemCount: 1,
              variantId: String(variantId),
              sections: response.sections || {},
              productId: button.dataset.productId,
            },
          },
        })
      );

      window.setTimeout(() => {
        button.innerHTML = originalHTML;
        button.disabled = false;
      }, 2000);
    })
    .catch((error) => {
      console.error('OBA add to cart error:', error);
      button.removeAttribute('data-loading');
      button.removeAttribute('aria-busy');
      button.innerHTML = '<span>Try again</span>';
      button.disabled = false;
      window.setTimeout(() => {
        button.innerHTML = originalHTML;
      }, 2500);
    });
};
